import React from 'react';

export default function IconTick() {
  return (
    <svg width="16px" height="12px" viewBox="0 0 16 12" version="1.1">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Agilytics-02" transform="translate(-761.000000, -27.000000)" fill="#FFFFFF" fillRule="nonzero">
          <g id="Group-6" transform="translate(761.000000, 23.000000)">
            <path
              d="M4.68349971,15.4478382 C5.04051674,15.8095994 5.51027598,16 6.01761597,16 C6.52495596,16 6.99471521,15.7905593 7.35173224,15.4478382 L15.4503817,7.24157081 C16.1832061,6.49900833 16.1832061,5.29948433 15.4503817,4.55692186 C14.7175573,3.81435938 13.5337639,3.81435938 12.8009395,4.55692186 L5.9988256,11.4113447 L3.19906048,8.57437525 C2.46623605,7.83181277 1.28244275,7.83181277 0.549618321,8.57437525 C-0.183206107,9.31693772 -0.183206107,10.5164617 0.549618321,11.2590242 L4.68349971,15.4478382 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
